import styled from 'styled-components';
import { Box } from '@mui/material';import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
export const ViewCountryHeadCountWrapper = styled(Dialog)`
.customDialogTitle {
    background-color: #1b4a83;
    text-align: end;
    color: #fff;
         }
         .customDialog
         {
            text-align: left;
            color:#000;
            font-family: 'Noto Sans', sans-serif;
         }
         table{
           
                // margin-top: 20px;
                border-collapse:separate;
                thead{
                    background-color: rgb(27, 74, 131);
                    th{
                        color: #fff;
                        font-size: 14px;
                        font-weight: 600;
                        background:rgb(27, 74, 131);
                        text-align: center;
                        font-family: 'Noto Sans', sans-serif;
                        .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {
                          opacity: 1;
                          color: #fff;
                      }
                       .MuiTableSortLabel-icon {
                          opacity: 1;
                          color: #fff;
                          font-size:20px;
                      }
                        div
                        {
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          position:relative;
                          button{
                            position:absolute;
                            right:0
                          }
                        }
                    }
                }
                    tbody{
                      tr{
                        td{
                            font-size: 14px;
                            text-align: center;
                            font-family: 'Noto Sans', sans-serif;                  }
                      }
                    }
                
            }
         
            .dialogbutton
            {
             text-align:center;
             display:block;
             font-family: 'Noto Sans', sans-serif;
            .confirmButton{
             text-align:center;
               background-color: #239155;
            }
            .rightButton {
             text-align:center;
              
             }
     
`;

export const ApprovalWorkflowDialogWrapper = styled(Dialog)`
height:100%;
.confirmationButtonBox{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.confirmationTextForVis{
  display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    padding-bottom: 0px;
}
.customDialogTitle {
    
    background-color: #1b4a83;
    text-align: center;
    color: #fff;
         }
         .customDialog
         {
            text-align: center;
            color:#000;
            img{
               display: block;
               margin: 10px auto; /* Center the image horizontally */
               max-width: 100px; /* Set the desired max width for the image */
           }
           .note
           {
            width:70%;
            text-align: left;
            font-weight:700;
            padding-left: 20px;
           }
           .confirmationText{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
           }
           .confirmationButton{
            display: flex;
            justify-content: center;
            padding-bottom: 30px;
           }
          .customDropdown
          { text-align: left;
            width:100%;
            padding-top:10px;
          }
          .errorBox
          {
            text-align: left;
          }
          span.error {
            
            color: #d32f2f;
            font-size:12px;
            line-height: 2;
            font-weight: 400;
        }
        span.red {
            color: #ff0000;
        }
        .errorInput {
            border: 1px solid #ff0000;
            border-radius: 5px;
        
        
          }
          .inputform
          {
            width:100%;
            padding-top:10px;
            .formValue{ width:100%;}
          }
         }
         .dialogbutton
         {
          text-align:center;
          display:block;
          margin-bottom: 10px;

         .confirmButton{
          text-align:center;
            background-color: #1b4a83;
            width:25%;
         }
         .rightButton {
          text-align:center;
          color:#1b4a83;
           width:25%;
           border-color: #1b4a83;
          }
        }
         .MuiBackdrop-root {
    background-color: rgba(0, 0, 0, 0.1) !important;
}
    .MuiDialog-paper {
        box-shadow: none;
    }
`;
